/**
 * AuthLayout — centered card on a soft canvas background.
 * Used by Login and Register screens. No sidebar, no topbar.
 *
 * Props:
 *   title    — heading shown above the form
 *   subtitle — optional descriptive line under the title
 *   children — the form content
 *   footer   — optional content below the card (e.g. "Already have an account?" link)
 *   wide     — when true, opens the card to ~760px for two-column forms.
 *              Default is ~448px (single-column).
 */

import { APP } from '../../data/constants.js';

export default function AuthLayout({ title, subtitle, children, footer, wide = false }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-4 sm:p-8">
      <div className={`w-full ${wide ? 'max-w-3xl' : 'max-w-md'}`}>
        {/* Brand */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div
            className="w-11 h-11 rounded-lg grid place-items-center text-white font-bold text-lg shadow-md"
            style={{
              background:
                'linear-gradient(135deg, var(--accent-600), var(--accent-700))',
              boxShadow:
                '0 4px 12px rgba(15,23,42,0.10), inset 0 1px 0 rgba(255,255,255,0.18)',
            }}
          >
            O
          </div>
          <div className="leading-tight">
            <div className="font-bold text-lg text-ink tracking-tight">
              {APP.NAME}
            </div>
            <div className="text-xs text-muted font-medium">
              {APP.COMPANY_SHORT}
            </div>
          </div>
        </div>

        {/* Card */}
        <div className="card p-6 sm:p-8">
          <div className="mb-6">
            <h1 className="text-xl font-bold text-ink tracking-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-muted mt-1">{subtitle}</p>
            )}
          </div>
          {children}
        </div>

        {/* Footer (e.g. "Already have an account?") */}
        {footer && (
          <div className="text-center text-sm text-muted mt-5">{footer}</div>
        )}
      </div>
    </div>
  );
}